
import React from 'react';
import { PROCESS_STEPS } from '../constants';

const Process: React.FC = () => {
  return (
    <section className="h-full w-full bg-black text-white relative overflow-hidden flex items-center">
      <div className="px-6 lg:px-20 max-w-[1440px] mx-auto w-full">
        <div className="grid lg:grid-cols-2 gap-12 lg:gap-20 items-center">
          <div className="">
            <h2 className="text-6xl lg:text-8xl font-black uppercase tracking-tighter italic leading-none mb-4">Our <br/>Process</h2>
            <div className="w-24 h-2 bg-primary mb-8 lg:mb-0"></div>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-x-8 gap-y-12">
            {PROCESS_STEPS.map((step, idx) => (
              <div key={idx} className="flex flex-col gap-2">
                <span className="text-3xl font-black text-white/20 block">{step.number}</span>
                <h3 className="text-xl font-black uppercase tracking-tight">{step.title}</h3>
                <p className="text-white/60 text-sm leading-relaxed">
                  {step.description}
                </p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Process;
